import { cardTypeDetector } from "./cardTypeUtil";

// Luhn algorithm for card number validation
export function isValidCardNumber(cardNumber) {
    const digits = (cardNumber || "").replace(/\D/g, "").split("").map(Number);
    if (digits.length < 15) return false;
    let sum = 0;
    let isEven = false;
    for (let i = digits.length - 1; i >= 0; i--) {
      let digit = digits[i];
      if (isEven) {
        digit *= 2;
        if (digit > 9) digit -= 9;
      }
      sum += digit;
      isEven = !isEven;
    }
    return sum % 10 === 0;
  }

// Validation functions
export function validateCardNumber(cardNumber, form, supportedCards) {
    const errorElement = form.querySelector("#card-error");
    const cardType = cardTypeDetector(cardNumber);
    if (!cardNumber) {
      errorElement.textContent = "Card number is required";
      return false;
    } else if (!isValidCardNumber(cardNumber)) {
      errorElement.textContent = "Invalid card number";
      return false;
    } else if (!cardType || !supportedCards.includes(cardType)) {
      errorElement.textContent = `Card must be ${supportedCards.join(", ")}`;
      return false;
    } else {
      errorElement.textContent = "";
      return true;
    }
  }  

// Validate expiry date (MM/YY, future date)
export function isValidExpiryDate(value) {
    if (!value || !value.match(/^(0[1-9]|1[0-2])\/\d{2}$/)) return false;
    const [month, year] = value.split("/").map(Number);
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear() % 100;
    const currentMonth = currentDate.getMonth() + 1;
    return (
      year > currentYear || (year === currentYear && month >= currentMonth)
    );
  } 
  
export function validateExpiryDate(value, form) {
    const errorElement = form.querySelector("#expiry-error");
    if (!value) {
      errorElement.textContent = "Expiry date is required";
      return false;
    } else if (!isValidExpiryDate(value)) {
      errorElement.textContent = "Invalid date";
      return false;
    } else {
      errorElement.textContent = "";
      return true;
    }
  }  


 export function validateCVC(value, form, cardType) {
    const errorElement = form.querySelector("#secret-error");
    const isAmex = cardType.toUpperCase() === "AMEX";
    if (!value) {
      errorElement.textContent = "CVC is required";
      return false;
    } else if (!value.match(/^\d{3,4}$/)) {
      errorElement.textContent = "Invalid CVC";
      return false;
    } else if (isAmex && value.length !== 4) {
      errorElement.textContent = "Amex CVC must be 4 digits";
      return false;
    } else if (!isAmex && value.length !== 3) {
      errorElement.textContent = "CVC must be 3 digits";
      return false;
    } else {
      errorElement.textContent = "";
      return true;
    }
  }  

  export function validateCardName(value, form) {
    const errorElement = form.querySelector("#card_name-error");
    if (!value) {
      errorElement.textContent = "Cardholder name is required";
      return false;
    } else if (!value.match(/^[a-zA-Z\s]+$/)) {
      errorElement.textContent = "Name must contain only letters and spaces";
      return false;
    } else {
      errorElement.textContent = "";
      return true;
    }
  }